export var TransmissionType;
(function (TransmissionType) {
    TransmissionType["AUTOMATIC_TRANSMISSION"] = "AUTOMATIC_TRANSMISSION";
    TransmissionType["MANUAL_TRANSMISSION"] = "MANUAL_TRANSMISSION";
    TransmissionType["UNKNOWN"] = "UNKNOWN";
})(TransmissionType || (TransmissionType = {}));
//# sourceMappingURL=transmissionType.js.map